import { useEffect, useState } from "react";
import { useAccount } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import { Trans } from "@lingui/macro";
import Button from "components/Button/Button";
import "./WalletBackdrop.scss";

export function WalletBackdrop() {
  const { isConnected } = useAccount();
  const { openConnectModal } = useConnectModal();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Listen for when RainbowKit modal opens/closes
    const checkModalState = () => {
      const rainbowKitModal = document.querySelector('[role="dialog"][aria-labelledby*="rk"]');
      setIsModalOpen(!!rainbowKitModal);
    };

    // Check immediately
    checkModalState();

    // Set up a mutation observer to watch for modal changes
    const observer = new MutationObserver(checkModalState);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  // Don't show backdrop if wallet is connected or modal is open
  if (isConnected || isModalOpen) {
    return null;
  }

  const handleButtonClick = () => {
    if (openConnectModal) {
      openConnectModal();
    }
  };

  return (
    <div className="wallet-backdrop">
      <div className="wallet-backdrop-content">
        <div className="wallet-backdrop-message">
          <h2 className="text-typography-primary">Connect Your Wallet</h2>
          <p className="text-typography-secondary">Please connect your wallet to continue trading</p>
          <Button variant="primary-action" className="w-full" onClick={handleButtonClick}>
            Connect Wallet
          </Button>
        </div>
      </div>
    </div>
  );
}
